<div class="scrollable-section" #scrollableSection>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">


      <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit()" novalidate="">
        <div class="block">
          <div class="col-14">
            <div class="row justify-content-center">

              <div class="col-12 ml-2">

                <div class="row">
                  <div class="col-6 ">
                    <app-form-input-app *ngIf="inputData" [labelText]="'Empresa'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" [readOnly]="true"
                        [(ngModel)]="appAttendanceSummaryModel.companyData.name" name="company" required="true">
                    </app-form-input-app>
                  </div>

                  <!--  <div class="col-6  mt-4 pt-1">
                    <app-dropdown-formularios *ngIf="inputData" dataSize="7" placeHolder="Válido"
                      [selectedValue]="valid === 'Sí'  ? 'true' : 'false'" (selectedValueChange)="validChange($event)"
                      [isDisabled]="false" [required]="true" [dropdownType]="'YesNo'" detailedData="true">
                    </app-dropdown-formularios>
                  </div> -->
                </div>
                <div class="col-12 ">
                  <dx-data-grid #dataGrid id="gridContainer" [dataSource]="dataSource" [paging]="{ pageSize: 6 }"
                    [pager]="{showPageSizeSelector: false,showNavigationButtons: true,visible: true}"
                    (onEditorPreparing)="onEditorPreparing($event)" (onRowPrepared)="onRowPrepared($event)"
                    (onExporting)="onExporting($event)" (onToolbarPreparing)="onToolbarPreparing1($event)">

                    <!-- Definición de las columnas -->

                    <dxi-column dataField="attendanceAt" [visible]="false" [sortOrder]="'asc'"
                      [showInColumnChooser]="false" sortIndex="0"><!-- Columna oculta para ordenar -->
                    </dxi-column>

                    <dxi-column dataField="valid" caption="Estado" alignment="center" [allowFiltering]="false"
                      cellTemplate="statusTemplate">
                    </dxi-column>

                    <dxi-column caption="Hora de marcaje local" dataType="date" alignment="center"
                      format="dd/MM/yyyy HH:mm" [allowFiltering]="false" cellTemplate="attendanceHourTemplate">
                    </dxi-column>
                    <dxi-column dataField="typeData.name" caption="Tipo" alignment="center"
                      cellTemplate="typeTemplate"></dxi-column>
                    <dxi-column dataField="source" caption="Origen" alignment="center" cellTemplate="sourceTemplate"
                      [calculateCellValue]="formatSource"></dxi-column>
                    <dxi-column dataField="workCenterData.name" caption="Centro" alignment="center"></dxi-column>
                    <dxi-column dataField="coordinates" caption="Localización" alignment="center"
                      [calculateCellValue]="formatCoordinates" cellTemplate="coordinatesTemplate"></dxi-column>

                    <!-- Templates -->

                    <ng-container *dxTemplate="let data of 'statusTemplate'">
                      <div class="status-container" [ngStyle]="{'background-color': getStatusColor(data.data.valid)}"
                        [matTooltip]="data.data.valid ? 'Válido' : getInvalidRecordTooltip(data.data.invalidReason)">
                        <fa-icon [icon]="getIconForStatus(data.data.valid)" style=" margin-top: 1px;"></fa-icon>
                      </div>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'attendanceHourTemplate'">
                      <span style="cursor: pointer;" [matTooltip]="data.data.timeZone ?? ''">
                        {{ adjustAttendanceTime(data.data) }}
                      </span>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'typeTemplate'">
                      <span style="cursor: pointer;" [matTooltip]="data.data.lastExitLocalTimeZone ?? ''">
                        <ng-container *ngIf="data.data.typeData?.entry === false">
                          {{ data.data.typeData?.name }}
                          <ng-container *ngIf="data.data.typeData?.imputable">
                            (suma jornada)
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="data.data.typeData?.entry !== false">
                          {{ data.data.typeData?.name }}
                        </ng-container>
                      </span>
                    </ng-container>
                    

                    <ng-container *dxTemplate="let data of 'sourceTemplate'">
                      <div class="source-container" [matTooltip]="data.data.source === 'APP' ? 'APP' : 'MANUAL'">
                        <fa-icon [icon]="getIconForSource(data.data.source)" style=" margin-top: 1px;"></fa-icon>
                      </div>
                    </ng-container>

                    <ng-container *dxTemplate="let data of 'coordinatesTemplate'">
                      <span *ngIf="data.data.coordinates" style="cursor: pointer;text-decoration: underline;"
                        (click)="onLocationCheck(data.data)">
                        {{ data.data.coordinates }}
                      </span>
                      <span *ngIf="!data.data.coordinates">
                        Sin localización
                      </span>
                    </ng-container>

                    <ng-container>
                      <dxi-column dataField="attendanceRecord1" caption="Acciones" [allowFiltering]="false"
                        [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"
                        [allowExporting]="false"></dxi-column>
                      <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                        <button rel="tooltip" type="button" class="btn btn-action btn-primary"
                          (click)="onClickToggleValid(data)"
                          [matTooltip]="data.data.valid ? 'Marcar como no válido' : 'Marcar como válido'">
                          <i class="material-icons">
                            {{ data.data.valid ? 'block' : 'check' }}
                          </i>
                        </button>
                        <button rel="tooltip" type="button" class="btn btn-action btn-primary"
                          (click)="onClickCheck(data.data)" matTooltip="Ver detalles">
                          <i class="material-icons">remove_red_eye</i>
                        </button>
                        <button rel="tooltip" type="button" class="btn btn-action"
                          [ngClass]="data.data.enabled ? 'btn-primary' : 'btn-default'" (click)="onClickDisable(data)"
                          [matTooltip]="data.data.enabled ? 'Deshabilitar' : 'Habilitar'">
                          <i class="material-icons">
                            {{ data.data.enabled ? 'toggle_on' : 'toggle_off' }}
                          </i>
                        </button>
                      </ng-container>
                    </ng-container>

                    <!-- Añadir nuevos -->
                    <!-- <div *dxTemplate="let data of 'addNew'">
                      <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd()">
                        <i class="material-icons">add</i>
                        <span class="d-none d-sm-inline-block">Nuevo</span>
                      </button>
                    </div> -->

                    <dxo-export [enabled]="true" [fileName]="generateExportFileName()"></dxo-export>
                  </dx-data-grid>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <!-- <button *ngIf="inputData" class="btn btn-fill btn-primary float-right" type="submit">Guardar</button> -->
              <a class="btn btn-fill btn-outline-white float-right" (click)="closePopUp()">Volver</a>
            </div>
          </div>
        </div>
      </form>
    </app-generic-panel>

  </div>




</div>